export default "__VITE_ASSET__CqLbXJKB__"